import React, { useState } from 'react';
import OverflowMenu from '../../utils/OverflowMenu';
import Modal from '../../Modal/Modal';
import styles from './RecommendationList.module.scss';

const RecommendationList = ({ recommendations, currentUser, onDelete }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);

  const handleDeleteClick = (rec) => {
    setSelectedRecommendation(rec);
    setShowConfirmDialog(true);
  };

  const confirmDelete = () => {
    if (selectedRecommendation) {
      onDelete(selectedRecommendation);
      setShowConfirmDialog(false);
      setSelectedRecommendation(null);
    }
  };

  return (
    <div className={styles.recommendations}>
      <h3>You might also like:</h3>
      {recommendations.map((rec, index) => {
        return (
          <div key={index} className={styles.recommendation}>
            <img src={rec.thumbnail} alt="Video thumbnail" />
            <div>
              <a href={rec.url} target="_blank" rel="noopener noreferrer">
                {rec.title}
              </a>
              <p>Recommended by: {rec.displayName}</p>
            </div>
            {currentUser && rec.userId === currentUser.uid && (
              <OverflowMenu
                options={[
                  {
                    label: 'Delete',
                    handler: () => handleDeleteClick(rec),
                    style: { color: '#EF4444' },
                  },
                ]}
              />
            )}
          </div>
        );
      })}

      {showConfirmDialog && (
        <Modal
          isOpen={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
        >
          <div className={styles.confirmDialog}>
            <p>Are you sure you want to delete this recommendation?</p>
            <button onClick={confirmDelete}>Yes, Delete</button>
            <button onClick={() => setShowConfirmDialog(false)}>Cancel</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default RecommendationList;
